<template>
  <AbsPopup id="PublicationInfo" title="책정보" @close="$emit('close')" @submit="submit">
    <template #body>
      <div class="popup-body">
        <div v-if="cover" class="cover">
          <UImage :value='cover' :width="325" @size="sizeInit"/>
          <span>{{ size }}</span>
        </div>
        <div>
          <EditTitleBar title="책 소개" :value.sync="description" :disable="true" align="left">
            <div v-if="tag !== undefined" class="tagList">
              <div v-for="(t, index) in tagList" :key="index" class="tagItem">
                <span>{{ t }}</span>
              </div>
            </div>
          </EditTitleBar>
          <EditTitleBar title="작가 소개" :value.sync="userdescription" :disable="true" align="left" />
        </div>
      </div>
    </template>
  </AbsPopup>
</template>

<script>
import AbsPopup from '@/components/popup/AbsPopup.vue'
import EditTitleBar from '@/components/layout/EditTitleBar.vue'
import UImage from '@/components/base/UImage.vue'

export default {
  props: {
    option: {
      type: Object
    }
  },
  watch: {
  },
  created () {
  },
  mounted () {
    this.$emit('loading', true)
    if (this.option.param) {
      if (this.option.param.intro) {
        this.cover = this.option.param.cover
        this.description = this.option.param.intro.description
        this.tag = this.option.param.intro.tag
        this.userdescription = this.option.param.intro.userdescription
        this.$emit('loading', false)
      } else {
        this.$http.post('/api/admin/publishing/info', {epub: this.option.param.id}).then((s) => {
          console.log('epub', s)
          if (s.success) {
            this.epub = s
            this.cover = s.cover
            this.description = s.intro.description
            this.tag = s.intro.tag
            this.userdescription = s.intro.userdescription
            this.$emit('loading', false)
          }
        })
      }
    }
  },
  data () {
    return {
      epub: null,
      cover: null,
      description: '',
      tag: '',
      userdescription: '',
      size: ''
    }
  },
  name: 'PublicationInfo',
  computed: {
    tagList () {
      return this.tag.split(',')
    }
  },
  methods: {
    sizeInit (size) {
      console.log(size)
      this.size = size
    },
    submit () {
      this.$emit('close')
    }
  },
  components: {
    AbsPopup,
    EditTitleBar,
    UImage
  }
}
</script>

<style scoped>
#PublicationInfo {
  padding: 10px 0;
  width: 800px;
}
.popup-body {
  display: flex;
  flex-direction: row;
  padding: 10px;
  width: 100%;
}
.popup-body .cover {
  display: flex;
  flex-direction: column;
}
.popup-body .cover img{
  width: 325px;
}
.popup-body > div {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.tagList {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 10px;
}
.tagList .tagItem {
  background-color: var(--disable);
  padding: 5px 14px;
  margin-bottom: 5px;
}
.tagList .tagItem:nth-child(1n+2) {
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/admin/PublicationInfo.vue